import styled from "styled-components";
import Box from "../../components/Box";
import Button from "../../components/Button";
import TextArea from "../../components/ManageOutlet/TextArea";
import Selectfield from "../../components/Merchant/Selectfield";
import Textfield from "../../components/Merchant/Textfield";
import { Colors, MERCHANT_STATUS } from "../../config/Constants";
import { CategoryDataType } from "../../pages/CreateCategory";
import Radio from "../ManagePromo/Radio";
import UploadLogoImages from "./UploadImage";
export interface CategoryDataTypeError {
  categoryName: string;
  status: string;
  categoryInformation: string;
  cardColorCode: string;
  productId: string;
  type: string;
  price: string;
  dependentProduct: string;
  logoUrl: string;
  aquaAvailableUnit: string;
  aquaGroup: string;
  imageUrl: string;
  taxClassification:string
}
interface CreateCategoryFormProps {
  onAddAnotherDuration: any;
  durations: any;
  uploadedImage: any;
  category: any;
  products: any;
  product: any;
  data: CategoryDataType;
  pricingData: any;
  priceData: {
    mon: string;
    tue: string;
    wed: string;
    thu: string;
    fri: string;
    sat: string;
    sun: string;
  };
  onChange: (e: any) => void;
  onPriceChange: (e: any) => void;
  onPricingChange: (e: any) => void;
  onAquaPriceChange: (e: any, idx: any) => void;
  onSubmit: () => void;
  onCancel: () => void;
  error: CategoryDataTypeError;
  priceError: {
    mon: string;
    tue: string;
    wed: string;
    thu: string;
    fri: string;
    sat: string;
    sun: string;
  };
  onRemove: any;
  taxClassificationList:any
}
const CreateCategoryForm = ({
  data,
  priceData,
  onChange,
  onPriceChange,
  error,
  onSubmit,
  onCancel,
  priceError,
  onPricingChange,
  pricingData,
  products,
  product,
  category,
  onRemove,
  uploadedImage,
  durations,
  onAddAnotherDuration,
  onAquaPriceChange,
  taxClassificationList
}: CreateCategoryFormProps) => {
  return (
    <Box>
      <FormWrapper>
        <FormRow>
          <FieldWrapper>
            <Textfield
              name="categoryName"
              label="Product Name"
              placeholder="Enter product name"
              onChange={onChange}
              value={data["categoryName"]}
              required
              helperText={error["categoryName"]}
            />
          </FieldWrapper>
          <FieldWrapper>
            <Selectfield
              name="status"
              label="Status"
              onChange={onChange}
              value={data["status"]}
              required
              helperText={error["status"]}
              data={MERCHANT_STATUS}
            />
          </FieldWrapper>
        </FormRow>

        {product === "aqua_zone" && (
          <FormRow>
            <FieldWrapper>
              <Selectfield
                name="aquaGroup"
                label="Category"
                onChange={onChange}
                value={data["aquaGroup"]}
                required
                helperText={error["aquaGroup"]}
                data={category}
              />
            </FieldWrapper>
            <FieldWrapper>
              {/* <Textfield
                name="categoryName"
                label="Subtitle"
                placeholder="Enter product name"
                onChange={onChange}
                value={data["categoryName"]}
                required
                helperText={error["categoryName"]}
              /> */}
            </FieldWrapper>
          </FormRow>
        )}

        <FormRow>
          <FieldWrapper>
            <TextArea
              label="Product Information"
              placeholder="Write about product"
              onChange={onChange}
              value={data["categoryInformation"]}
              name="categoryInformation"
              required
              helperText={error["categoryInformation"]}
              rows={9}
            />
          </FieldWrapper>
          <FieldWrapper>
            <Textfield
              name="productId"
              label="Product ID for Category"
              placeholder="Enter Product ID"
              onChange={onChange}
              value={data["productId"]}
              required
              helperText={error["productId"]}
            />
            <br />
            {product !== "aqua_zone" ? (
              <Textfield
                name="cardColorCode"
                label="Card color code"
                placeholder="Enter card color code"
                onChange={onChange}
                value={
                  data["cardColorCode"] === ""
                    ? "CCCCCC"
                    : data["cardColorCode"]
                }
                required
                helperText={error["cardColorCode"]}
                disabled
              />
            ) : (
              <>
                <Textfield
                  name="aquaAvailableUnit"
                  label="Inventory"
                  placeholder="Enter count"
                  onChange={onChange}
                  value={data["aquaAvailableUnit"]}
                  required
                  helperText={error["aquaAvailableUnit"]}
                />
              </>
            )}
          </FieldWrapper>
        </FormRow>

        <FormRow>
          <FieldWrapper>
            <Label>
              Product Dependent<span>*</span>
            </Label>
            <RadioGroup>
              <Radio
                label="Is Independent"
                selected={data.isDependent === false}
                onClick={() =>
                  onChange({ target: { value: false, name: "isDependent" } })
                }
              />
              <Radio
                label="Is Dependent"
                selected={data.isDependent === true}
                onClick={() =>
                  onChange({ target: { value: true, name: "isDependent" } })
                }
              />
            </RadioGroup>
          </FieldWrapper>

          <FieldWrapper>
            {product !== "aqua_zone" && (
              <Selectfield
                name="dependentProduct"
                label="Dependent Product"
                onChange={onChange}
                value={data["dependentProduct"]}
                required
                helperText={error["dependentProduct"]}
                disabled={!data.isDependent}
                data={[
                  { label: "Select Dependent Product", value: "" },
                  ...products,
                ]}
              />
            )}
          </FieldWrapper>
        </FormRow>
        {/* <FormRow>
          <FieldWrapper>
            <Label>
              Is Taxable
            </Label>
            <RadioGroup>
              <Radio
                label="Yes"
                selected={data.isTaxEnabled === true}
                onClick={() =>
                  onChange({ target: { value: true, name: "isTaxEnabled" } })
                }
              />
              <Radio
                label="No"
                selected={data.isTaxEnabled === false}
                onClick={() =>
                  onChange({ target: { value: false, name: "isTaxEnabled" } })
                }
              />
            </RadioGroup>
          </FieldWrapper>
          <FieldWrapper>
            <Selectfield
              name="taxClassification"
              label="Tax Type"
              onChange={onChange}
              value={data["taxClassification"]}
              required={data.isTaxEnabled}
              disabled={!data.isTaxEnabled}
              helperText={error["taxClassification"]}
              data={taxClassificationList}
            />
          </FieldWrapper>
        </FormRow> */}
        {product !== "aqua_zone" ? (
          <>
            <FormRow>
              <FieldWrapper>
                <Selectfield
                  name="type"
                  label="Type of Price"
                  onChange={onPricingChange}
                  value={pricingData["type"]}
                  required
                  helperText={error["type"]}
                  data={[
                    { label: "Select Price Type", value: "" },
                    { label: "Single Price", value: "single" },
                    { label: "Multi Price", value: "multi" },
                  ]}
                />
              </FieldWrapper>
              <FieldWrapper>
                <Textfield
                  name="price"
                  label="Mon to Sun"
                  placeholder="Enter Price"
                  onChange={onPricingChange}
                  value={pricingData["price"]}
                  required={pricingData["type"] === "single"}
                  disabled={pricingData["type"] !== "single"}
                  helperText={error["price"]}
                />
              </FieldWrapper>
            </FormRow>
            <FormRow>
              <FieldWrapper>
                <Label>
                  Price<span>*</span>
                </Label>
                <DayPriceDivWrapper>
                  <Textfield
                    name="mon"
                    label="Mon"
                    placeholder="Enter Price"
                    onChange={onPriceChange}
                    value={priceData["mon"]}
                    helperText={priceError["mon"]}
                    disabled={pricingData["type"] !== "multi"}
                    isDaysTextField
                  />
                  <Textfield
                    name="tue"
                    label="Tue"
                    placeholder="Enter Price"
                    onChange={onPriceChange}
                    value={priceData["tue"]}
                    helperText={priceError["tue"]}
                    disabled={pricingData["type"] !== "multi"}
                    isDaysTextField
                  />
                  <Textfield
                    name="wed"
                    label="Wed"
                    placeholder="Enter Price"
                    onChange={onPriceChange}
                    value={priceData["wed"]}
                    helperText={priceError["wed"]}
                    disabled={pricingData["type"] !== "multi"}
                    isDaysTextField
                  />
                  <Textfield
                    name="thu"
                    label="Thu"
                    placeholder="Enter Price"
                    onChange={onPriceChange}
                    value={priceData["thu"]}
                    helperText={priceError["thu"]}
                    disabled={pricingData["type"] !== "multi"}
                    isDaysTextField
                  />
                  <Textfield
                    name="fri"
                    label="Fri"
                    placeholder="Enter Price"
                    onChange={onPriceChange}
                    value={priceData["fri"]}
                    helperText={priceError["fri"]}
                    disabled={pricingData["type"] !== "multi"}
                    isDaysTextField
                  />
                  <Textfield
                    name="sat"
                    label="Sat"
                    placeholder="Enter Price"
                    onChange={onPriceChange}
                    value={priceData["sat"]}
                    helperText={priceError["sat"]}
                    disabled={pricingData["type"] !== "multi"}
                    isDaysTextField
                  />
                  <Textfield
                    name="sun"
                    label="Sun"
                    placeholder="Enter Price"
                    onChange={onPriceChange}
                    value={priceData["sun"]}
                    helperText={priceError["sun"]}
                    disabled={pricingData["type"] !== "multi"}
                    isDaysTextField
                  />
                </DayPriceDivWrapper>
              </FieldWrapper>
            </FormRow>
          </>
        ) : (
          <>
            <FormRow>
              <FieldWrapper>
                <UploadLogoImages
                  name="imageUrl"
                  label="Upload Outlet image"
                  onChange={onChange}
                  onRemove={onRemove}
                  required
                  uploadedImage={uploadedImage}
                  helperText={error["imageUrl"]}
                  maxImages={5}
                  subLabel="Only JPEG or PNG files are allowed. Max size: 2MB. Recommended dimensions: 672x378."
                  urls={data.imageUrl}
                  acceptFormats=".jpeg, .jpg, .png"
                />
              </FieldWrapper>
            </FormRow>
            <DatePriceFormRow>
              <Label>
                Duration & Price <span>*</span>
              </Label>
              {durations.map((val: any, idx: number) => (
                <DatePriceWrapper>
                  <Textfield
                    name="duration"
                    label="Duration (in min)"
                    placeholder="Enter Time"
                    onChange={(e) => onAquaPriceChange(e, idx)}
                    value={val.value}
                    helperText={priceError["sun"]}
                    isDaysTextField
                  />
                  <Textfield
                    name="price"
                    label="Price (in QAR)"
                    placeholder="Enter Price"
                    onChange={(e) => onAquaPriceChange(e, idx)}
                    value={val.price}
                    helperText={priceError["sun"]}
                    isDaysTextField
                  />
                </DatePriceWrapper>
              ))}
            </DatePriceFormRow>
            <DatePriceFormRow>
              <AddNewDurationPrice onClick={onAddAnotherDuration}>
                Add Another Duration and Price
              </AddNewDurationPrice>
            </DatePriceFormRow>
          </>
        )}
      </FormWrapper>
      <ActionRow>
        <ButtonWrapper>
          <Button
            variant="outlined"
            label="Cancel"
            onClick={onCancel}
            width="9.7rem"
          />
          <Button
            color={Colors.red}
            variant="filled"
            label="Save"
            onClick={onSubmit}
            width="9.7rem"
          />
        </ButtonWrapper>
      </ActionRow>
    </Box>
  );
};

export default CreateCategoryForm;

const AddNewDurationPrice = styled.div`
  color: #2ca5ff;
  font-size: 0.9rem;
  text-decoration: underline;
`;

export const DatePriceWrapper = styled.div`
  display: flex;
  gap: 1rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const DatePriceFormRow = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
`;

export const FieldWrapper = styled.div`
  flex: 1;
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;

export const ButtonWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
    margin-top: 2rem;
  }
`;

export const ActionRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 4rem;
  @media only screen and (max-width: 768px) {
    margin-top: 0rem;
  }
`;

export const FormRow = styled.div`
  display: flex;
  gap: 0.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
  }
`;

const Label = styled.label`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 350;
  font-size: 13px;
  line-height: 16px;
  color: ${Colors.electricBlue};
  margin-bottom: 0.5rem;
  > span {
    color: ${Colors.red};
    margin-left: 2px;
  }
`;

const DayPriceDivWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.7rem;
  padding: 1.4388rem 0rem;
  flex-wrap: wrap;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const RadioGroup = styled.div`
  display: flex;
  gap: 2rem;
  padding: 0.5rem 0;
`;
